<template>
  <div class="d-flex align-start mb-2">
    <v-icon color="grey" class="mr-3 mt-1">{{ icon }}</v-icon>
    <div>
      <div class="text-caption text--secondary">{{ label }}</div>
      <div class="text-subtitle-1 font-weight-medium">{{ value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoItem",
  props: {
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
